import axiosInstance from '../config/axios';

export interface Salesperson {
  salespersonCode: string;
  salespersonFirstLastName: string;
  salespersonTeamCode?: string;
  salespersonTeam?: string;
  salespersonTypeCode?: string;
  salespersonType?: string;
  companyCode?: string;
  companyName?: string;
  officeCode?: string;
  officeDescription?: string;
  storeCode?: string;
  storeDescription?: string;
  employeeCode?: string;
  firstLastName?: string;
  signOff?: boolean | null;
  isWorkOnWholesale: boolean;
  isWorkOnRetail: boolean;
  isBlocked: boolean;
}

interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data: T;
}

// axiosInstance baseURL zaten API_BASE_URL'e kurulu
const BASE = ''; // instance baseURL kullan

export const salespersonApi = {
  async getSalespersons(langCode: string = 'TR'): Promise<Salesperson[]> {
    const url = `/api/v1/Salesperson?langCode=${encodeURIComponent(langCode)}`;
    const res = await axiosInstance.get<ApiResponse<Salesperson[]>>(url, {
      withCredentials: false,
    });
    return res.data.data ?? [];
  },
  // Belirli bir veritabanı için (header: X-Database-Id) satış sorumluları
  async getSalespersonsByDatabaseId(databaseId: string, langCode: string = 'TR'): Promise<Salesperson[]> {
    const url = `/api/v1/Salesperson?langCode=${encodeURIComponent(langCode)}`;
    const res = await axiosInstance.get<ApiResponse<Salesperson[]>>(url, {
      headers: { 'X-Database-Id': databaseId },
      withCredentials: false,
    });
    return res.data.data ?? [];
  },
};
